import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useScenes(groups = []) {
  const queryKey = ['locations', 'scenes', groups];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      const json = [
        { $match: { type: 'SCENE' } },
        {
          $graphLookup: {
            from: 'groups',
            startWith: '$groupCodes',
            connectFromField: 'parentCodes',
            connectToField: 'code',
            as: 'groupAncestorCodes',
            depthField: 'depth',
          },
        },
        {
          $lookup: {
            from: 'people',
            localField: 'code',
            foreignField: 'currentLocations.code',
            as: 'currentAttendees',
            pipeline: [
              {
                $project: {
                  _id: false,
                  forenames: true,
                  surname: true,
                  collarNumber: true,
                },
              },
            ],
          },
        },
        {
          $set: {
            groupAncestorCodes: {
              $map: {
                input: '$groupAncestorCodes',
                as: 'group',
                in: '$$group.code',
              },
            },
            groups: {
              $map: {
                input: {
                  $filter: {
                    input: '$groupAncestorCodes',
                    cond: { $eq: ['$$group.depth', 0] },
                    as: 'group',
                  },
                },
                as: 'group',
                in: '$$group.name',
              },
            },
          },
        },
        groups.length > 0 && {
          $match: { groupAncestorCodes: { $in: groups } },
        },
        { $sort: { name: 1 } },
      ].filter(Boolean);

      log('Read', 'Scenes');

      return api.post('pipeline/locations', { json, signal }).json();
    },
    placeholderData: [],
    staleTime: 30 * 60 * 1000,
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
